module.exports = __webpack_public_path__ + "static/media/facebook-red.a85ccc20.png";